module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00045-fs8.63ea6eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00045-fs8.png
// module id = 198
// module chunks = 0